export default function getQuestionChoices(question) {
	const output = {};

	for (const choice of question.choices) {
		output[choice.letter] = choice;
	}
	return output;
}
